import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';
import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { TODO } from '@b2c/types/index';
import angular from 'angular';

export const SalesRuleServiceModule = angular.module('acme.common.service.salesRule', [
  QueryStringBuilderFactoryModule,
  ApiVersionFactoryModule
])
.service('SalesRuleService', ['$http', 'QueryStringBuilderFactory', 'ApiVersionFactory', function($http, QueryStringBuilderFactory, ApiVersionFactory) {

    return {

      api: {
        validateSalesRules: function(props) {
          var av = new ApiVersionFactory();
          return $http({
            method: 'post',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: av.init({url: '/v1/b2c/entitlements/validate', version: 'v2'}),
            data: {
              id:  props.shoppingCartId
            }
          });
        }
      },

      init: function() {
        return true;
      },

      limits: {},
      results: [],

      timeFrames: {
        day: {
          name: 'day',
          label: 'per day'
        },
        week: {
          name: 'week',
          label: 'per week'
        },
        month: {
          name: 'month',
          label: 'per month'
        },
        year: {
          name: 'year',
          label: 'per year'
        },
        event: {
          name: 'lifetime',
          label: 'per event'
        }
      },

      ruleTypes: [
        {
          label: 'Member',
          name: 'memberBenefits'
        },
        {
          label: 'Event',
          name: 'eventSales'
        }
      ],

      reasonTypes: [
        {
          label: 'Cart',
          name: 'Cart'
        },
        {
          label: 'Transaction',
          name: 'Transaction'
        }
      ],

      resetLimits: function() {
        this.limits = {};
      },

      findTimeFrame: function(timeFrame) {
        var r = null;

        if (timeFrame) {
          switch(timeFrame.toLowerCase()) {
            case this.timeFrames.day.name:
              r = this.timeFrames.day;
              break;
            case this.timeFrames.week.name:
              r = this.timeFrames.week;
              break;
            case this.timeFrames.month.name:
              r = this.timeFrames.month;
              break;
            case this.timeFrames.year.name:
              r = this.timeFrames.year;
              break;
            case this.timeFrames.event.name:
              r = this.timeFrames.event;
              break;
          }
        }

        return r;
      },

      arePricePointsEqual: function(src, dest) {
        var r = false;

        if ( (src instanceof Array) && (dest instanceof Array) ){
          r = (src.join('') === dest.join(''));
        }

        return r;
      },

      processSalesRulesLimits: function(limitsData, results) {
        var eventId;
        var allowedQuantity;
        var purchasedQuantity;
        var inCartLimit;
        var pricePointId;
        let pricePointIds: TODO[] = [];
        let validatedPricePointIds: TODO[] = [];
        var ruleType;
        var isRetail = false;
        var timeFrame = null;
        var isPreventRule = false;

        this.resetLimits();

        if (results && results instanceof Array) {
          this.results = results;
        }

        if (limitsData instanceof Array) {
          for (let i = 0, ii = limitsData.length; i < ii; i++) {
            pricePointIds = [];
            validatedPricePointIds = [];
            pricePointId = null;
            ruleType = this.ruleTypes[0];
            isPreventRule = false;
            allowedQuantity = limitsData[i].allowedQuantity;
            purchasedQuantity = limitsData[i].purchasedQuantity || 0;
            inCartLimit = (limitsData[i].reason === this.reasonTypes[0].name) || false;
            isRetail = !!limitsData[i].isRetail && true;
            if (limitsData[i].timeFrame) {
              timeFrame = this.findTimeFrame(limitsData[i].timeFrame);
            }

            if (limitsData[i].hasOwnProperty('pricePointIds') && limitsData[i].pricePointIds instanceof Array) {
              if (limitsData[i].pricePointIds.length > 1) {
                pricePointIds = limitsData[i].pricePointIds ?? [];
              } else if (limitsData[i].pricePointIds.length === 1){
                pricePointId = limitsData[i].pricePointIds[0];
              }
            } else if (limitsData[i].hasOwnProperty('pricePointId')) {
              pricePointId = limitsData[i].pricePointId;
            }

            if (limitsData[i].hasOwnProperty('validatedPricePointIds') && limitsData[i].validatedPricePointIds instanceof Array) {
              validatedPricePointIds = limitsData[i].validatedPricePointIds ?? [];
            }

            eventId = limitsData[i].eventId;
            ruleType = (limitsData[i].ruleType && (limitsData[i].ruleType === this.ruleTypes[1].name)) ? this.ruleTypes[1] : this.ruleTypes[0];

            // if this is an event sales rule and the pricepoints being purchased are the same as the pricepoints that are limited, then this is not a prevent rule
            if (ruleType === this.ruleTypes[1] && !this.arePricePointsEqual((pricePointIds.length ?  pricePointIds : [pricePointId]), validatedPricePointIds)) {
              isPreventRule = true;
            }

            if ((allowedQuantity !== undefined && allowedQuantity !== null) && eventId) {
              if (!this.limits.hasOwnProperty(eventId)) {
                this.limits[eventId] = {
                  items: []
                };
              }
              this.limits[eventId].items.push( angular.extend({
                maxLimit: allowedQuantity,
                purchasedQuantity: purchasedQuantity,
                ticketTypeId: pricePointId,
                ticketTypeIds: pricePointIds,
                //this is a hack to consolidate prevented ticket types within the same cart
                validatedTicketTypeIds: (isPreventRule && inCartLimit) ? (validatedPricePointIds.concat(pricePointId ? [pricePointId] : pricePointIds)) : validatedPricePointIds,
                isRetail: isRetail,
                timeFrame: timeFrame,
                ruleType: ruleType,
                isPreventRule: isPreventRule,
                inCartLimit: inCartLimit
              }) );
            }
          }

        }
        return this.limits;
      },

      getRemainingLimit: function(eventId, ticketTypeId, isRetail) {
        var items;
        var i, ii;
        var result: TODO | null = null;
        var itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  if (items[i].isPreventRule) {
                    result = 0;
                    break;
                  } else {
                    result = (items[i].inCartLimit) ? items[i].maxLimit : items[i].maxLimit - items[i].purchasedQuantity;
                    if (result < 0) {
                      result = 0;
                    }
                    break;
                  }
                }
              } else {
                if (((items[i].ticketTypeId === ticketTypeId) || (items[i].ticketTypeIds.indexOf(ticketTypeId) > -1)) && itemIsRetail === isRetail) {
                  result = items[i].maxLimit - (items[i].purchasedQuantity || 0);
                  if (result < 0) {
                    result = 0;
                  }
                  break;
                }
              }
            }
          }
        }
        return result;
      },

      getTestResults: function functionName() {
        return this.results;
      },

      getTicketLimit: function(eventId, ticketTypeId, isRetail) {
        var items,
            i, ii,
            r = null,
            itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              // limit per ticket type
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].isPreventRule ? 0 : items[i].maxLimit;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].maxLimit;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      getTicketPurchased: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].purchasedQuantity;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].purchasedQuantity;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      getTimeFrame: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if (( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].timeFrame;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].timeFrame;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      getRuleType: function(eventId, ticketTypeId, isRetail) {
        var items,
          i, ii,
          r = null,
          itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ( ( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  r = items[i].ruleType;
                  break;
                }
              } else {
                if ((items[i].ticketTypeId === ticketTypeId) && itemIsRetail === isRetail) {
                  r = items[i].ruleType;
                  break;
                }
              }
            }
          }
        }
        return r;
      },

      isPreventRule: function(eventId, ticketTypeId, isRetail) {
        var items;
        var i, ii;
        var result: TODO | null = null;
        var itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ( ( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  result = items[i].isPreventRule;
                  break;
                }
              } else {
                result = false;
                break;
              }
            }
          }
        }
        return result;
      },

      isInCartLimit: function(eventId, ticketTypeId, isRetail) {
        var items;
        var i, ii;
        var result: TODO | null = null;
        var itemIsRetail;

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ( ( (items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length <= 1) && (items[i].validatedTicketTypeIds.indexOf(ticketTypeId) > -1) ) && itemIsRetail === isRetail) {
                  result = items[i].inCartLimit;
                  break;
                }
              } else {
                result = false;
                break;
              }
            }
          }
        }
        return result;
      },

      getViolationForTicketType: function(eventId, ticketTypeId, isRetail){
        return {
          limit: this.getTicketLimit(eventId, ticketTypeId, isRetail),
          remaining: this.getRemainingLimit(eventId, ticketTypeId, isRetail),
          purchased: this.getTicketPurchased(eventId, ticketTypeId, isRetail),
          timeFrame: this.getTimeFrame(eventId, ticketTypeId, isRetail),
          ruleType: this.getRuleType(eventId, ticketTypeId, isRetail),
          isPreventRule: this.isPreventRule(eventId, ticketTypeId, isRetail),
          inCartLimit: this.isInCartLimit(eventId, ticketTypeId, isRetail)
        };
      },

      getGroupViolationsForEvent: function(eventId, isRetail) {
        var items;
        var i, ii;
        var itemIsRetail;
        var groups: TODO[] = [];

        isRetail = isRetail || false;

        if (this.limits.hasOwnProperty(eventId)) {
          items = this.limits[eventId].items;
          if (items instanceof Array && items.length) {
            for (i=0, ii=items.length; i < ii; i++) {
              // limit across ticket types
              itemIsRetail = !!items[i].isRetail && true;

              if (items[i].ruleType === this.ruleTypes[1]) {
                if ((items[i].validatedTicketTypeIds instanceof Array) && (items[i].validatedTicketTypeIds.length > 1) &&
                  itemIsRetail === isRetail) {
                  groups.push( {
                    limit: items[i].isPreventRule ? 0 : items[i].maxLimit,
                    remaining: (items[i].inCartLimit) ? items[i].maxLimit : Math.max(items[i].maxLimit - (items[i].purchasedQuantity || 0), 0),
                    purchased: items[i].purchasedQuantity,
                    groupId: items[i].validatedTicketTypeIds.join('-'),
                    timeFrame: items[i].timeFrame,
                    ruleType: items[i].ruleType,
                    isPreventRule: items[i].isPreventRule,
                    inCartLimit: items[i].inCartLimit,
                    fails: items[i].fails || [],
                    violation: items[i]
                  } );
                }
              } else {
                if ((items[i].ticketTypeIds instanceof Array) && (items[i].ticketTypeIds.length) &&
                  itemIsRetail === isRetail) {
                  groups.push( {
                    limit: items[i].maxLimit,
                    remaining: Math.max(items[i].maxLimit - (items[i].purchasedQuantity || 0), 0),
                    purchased: items[i].purchasedQuantity,
                    groupId: items[i].ticketTypeIds.join('-'),
                    timeFrame: items[i].timeFrame,
                    ruleType: items[i].ruleType,
                    isPreventRule: items[i].isPreventRule,
                    inCartLimit: items[i].inCartLimit
                  } );
                }
              }
            }
          }
        }

        return groups.length ? this.consolidateDuplicatePreventRuleGroupIds(groups) : null;
      },

      consolidateDuplicatePreventRuleGroupIds: function(groups) {
        var sortedGroupTicketTypeIds = {};
        var uniqueGroups: TODO[] = [];

        angular.forEach(groups, function(group) {
          if (group.inCartLimit) {
            var groupTicketTypeIds = group.groupId.split('-'),
              sortedGroupTicketTypeId = groupTicketTypeIds.sort().join('-');
            if (!sortedGroupTicketTypeIds[sortedGroupTicketTypeId]) {
              sortedGroupTicketTypeIds[sortedGroupTicketTypeId] = 1;
            }
          }
        });

        angular.forEach(groups, function(group) {
          if (!group.inCartLimit) {
            uniqueGroups.push(group);
          } else {
            var groupId = group.groupId.split('-').sort().join('-');
            if (sortedGroupTicketTypeIds[groupId]) {
              uniqueGroups.push(group);
            }
          }
        });

        return uniqueGroups;
      },

      hasRemainingForTicket: function(ticket, limitsMap) {
        var type = ticket.isRetail ? 'retail': 'regular',
          remaining = (limitsMap) && (limitsMap[ticket.ticketTypeId] &&
          limitsMap[ticket.ticketTypeId][type]) ? limitsMap[ticket.ticketTypeId][type].remaining : null;
        return (remaining !== null);
      },

      hasRemainingForGroup: function(eventId, isRetail, groupLimitsMap) {
        var type =  isRetail ? 'retail': 'regular',
          remaining = (groupLimitsMap[type]) ? groupLimitsMap[type].remaining : null;
        return (remaining !== null);
      },

      checkRemaining: function(ticket, eventId, isRetail, limitsMap, groupLimitsMap) {
        var r,
          perTicketLimit = this.hasRemainingForTicket(ticket, limitsMap),
          groupLimit = this.hasRemainingForGroup(eventId, isRetail, groupLimitsMap);

        r = perTicketLimit || groupLimit;

        return r;
      },

      checkLimitErrors: function(tickets, eventId, limitsMap, groupLimitsMap) {
        var r = false,
          regularLimitExceeded,
          retailLimitExceeded,
          i, ii;

        if (tickets instanceof Array) {
          for (i = 0, ii = tickets.length; i < ii; i++) {
            regularLimitExceeded = this.checkRemaining(tickets[i], eventId, false, limitsMap, groupLimitsMap);
            retailLimitExceeded = this.checkRemaining(tickets[i], eventId, true, limitsMap, groupLimitsMap);
            if (!r) {
              r = regularLimitExceeded || retailLimitExceeded;
              if (r) {
                break;
              }
            }
          }
        }

        return r;
      },

      getGroupViolationsForEventWithNames: function(eventId, tickets, isRetail) {
        var self = this;
        var violations = this.getGroupViolationsForEvent(eventId, isRetail);

        if (violations instanceof Array) {
          angular.forEach(violations, function(violation) {
            var ticketTypeIds = violation.groupId ? violation.groupId.split('-') : [],
              names = self.getNamesForTicketTypes(ticketTypeIds, tickets);
            violation.ticketTypes = names.length ? names.join(', ') : '';
          });
        }

        return violations;
      },

      getNamesForTicketTypes: function(ticketTypeIds, tickets) {
        var found: TODO[] = [];
        var names: string[] = [];

        if ((tickets instanceof Array) && (ticketTypeIds instanceof Array)) {

          angular.forEach(ticketTypeIds, function(ticketTypeId) {

            found = tickets.filter(function(ticket) {
              return (ticket.ticketTypeId === ticketTypeId);
            });

            if (found && found.length) {
              names.push(found[0].name || found[0].description || '');
            }

          });
        }

        return names;
      },

      getMemberTicketLimit: function(tickets, eventId) {
        var self = this;
        var ticketLimitMap: TODO = {};
        var hasLimits = false;

        if (tickets instanceof Array) {

          angular.forEach(tickets, function (ticket) {

            ticketLimitMap[ticket.ticketTypeId] = {
              regular: self.getViolationForTicketType(eventId, ticket.ticketTypeId, false),
              retail: self.getViolationForTicketType(eventId, ticket.ticketTypeId, true)
            };

            if (!hasLimits && ticketLimitMap[ticket.ticketTypeId] &&
              ((ticketLimitMap[ticket.ticketTypeId]['regular'] && (ticketLimitMap[ticket.ticketTypeId]['regular'].limit !== null)) ||
              (ticketLimitMap[ticket.ticketTypeId]['retail'] && (ticketLimitMap[ticket.ticketTypeId]['retail'].limit !== null)))) {
              hasLimits = true;
            }
          });
        }

        return angular.extend(ticketLimitMap, {hasLimits: hasLimits});
      },

      getMemberGroupLimit: function(tickets, eventId) {

        var groupLimitMap: TODO = {};

        if (eventId && (tickets instanceof Array) && tickets.length) {

          groupLimitMap = {
            regular: this.getGroupViolationsForEventWithNames(eventId, tickets, false),
            retail: this.getGroupViolationsForEventWithNames(eventId, tickets, true)
          };

          if (!groupLimitMap.hasLimits && groupLimitMap['regular'] || groupLimitMap['retail']) {
            groupLimitMap.hasLimits = true;
          }
        }

        return groupLimitMap;
      },

      hasTicketErrors: function(ticketTypeId, isRetail, limitsMap) {
        var type = isRetail ? 'retail': 'regular',
          remaining = (limitsMap[ticketTypeId] &&
          limitsMap[ticketTypeId][type]) ? limitsMap[ticketTypeId][type].remaining : null;
        return (remaining !== null);
      },

      hasGroupErrors: function(eventId, isRetail, groupLimitsMap) {
        var type =  isRetail ? 'retail': 'regular',
          remaining = (groupLimitsMap[type]) ? groupLimitsMap[type].remaining : null;
        return (remaining !== null);
      }

    };

}]).name;